import { combineReducers } from 'redux-immutable';
import { reducer as formReducer } from 'redux-form/immutable';

import auth from './modules/auth';
import clients from './modules/clients';
import sessions from './modules/sessions';
import locations from './modules/locations';

export default combineReducers({
  [auth.constants.NAME]: auth.reducer,
  [clients.constants.NAME]: clients.reducer,
  [sessions.constants.NAME]: sessions.reducer,
  [locations.constants.NAME]: locations.reducer,
  form: formReducer
});



// WEBPACK FOOTER //
// ./src/rootReducer.js